import React, { useState, useRef, useEffect } from 'react';
import styles from './RecordDropdown.module.css';
import useTheme from 'config/useTheme';
import { ArrowDownIcon } from 'assets/icons';

const RecordDropdown = ({ label, options, onChange }) => {
  const { dark } = useTheme();
  const [drop, setDrop] = useState(false);
  const dropdownRef = useRef();
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDrop(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setDrop(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`${styles.record_dropdown} ${dark ? styles.dark : ''}`}
    >
      <button type="button" onClick={() => setDrop(!drop)}>
        {label || 'Select'} <ArrowDownIcon color="#757575" />
      </button>

      {drop && (
        <div className={styles.options}>
          {options.map((option, idx) => (
            <button key={idx} type="button" onClick={() => handleSelect(option)}>
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecordDropdown;
